import {
    actionTypes as MainMenuActionTypes,
    actions as MainMenuActions,
    reducer as MainMenuReducer,
    selectors as MainMenuSelectors
} from './MainMenu';

import {
    actionTypes as OptionsMenuActionTypes,
    actions as OptionsMenuActions,
    reducer as OptionsMenuReducer,
    selectors as OptionsMenuSelectors
} from './OptionsMenu';

import {
    actionTypes as ValueDateCalendarActionTypes,
    actions as ValueDateCalendarActions,
    reducer as ValueDateCalendarReducer,
    selectors as ValueDateCalendarSelectors
} from './ValueDateCalendar';

import {
    actionTypes as LocaleActionTypes,
    actions as LocaleActions,
    reducer as LocaleReducer,
    selectors as LocaleSelectors
} from './Locale';

import {
    actionTypes as HomeOptionsActionTypes,
    actions as HomeOptionsActions,
    reducer as HomeOptionsReducer,
    selectors as HomeOptionsSelectors
} from './HomeOptions';

import {
    actionTypes as SpotOptionsActionTypes,
    actions as SpotOptionsActions,
    reducer as SpotOptionsReducer,
    selectors as SpotOptionsSelectors
} from './SpotOptions';

import {
    actionTypes as ForwardOptionsActionTypes,
    actions as ForwardOptionsActions,
    reducer as ForwardOptionsReducer,
    selectors as ForwardOptionsSelectors
} from './ForwardOptions';

import {
    actionTypes as SettlementOptionsActionTypes,
    actions as SettlementOptionsActions,
    reducer as SettlementOptionsReducer,
    selectors as SettlementOptionsSelectors
} from './SettlementOptions';

import {
    actionTypes as SettlementActionTypes,
    actions as SettlementActions,
    reducer as SettlementReducer,
    selectors as SettlementSelectors
} from './Settlement';

import {
    actionTypes as BreakpointActionTypes,
    actions as BreakpointActions,
    reducer as BreakpointReducer,
    selectors as BreakpointSelectors
} from './Breakpoint';

import {
    actionTypes as StickyHeaderActionTypes,
    actions as StickyHeaderActions,
    reducer as StickyHeaderReducer,
    selectors as StickyHeaderSelectors
} from './StickyHeader';

export const actionTypes = {
    MainMenu: MainMenuActionTypes,
    OptionsMenu: OptionsMenuActionTypes,
    Locale: LocaleActionTypes,
    HomeOptions: HomeOptionsActionTypes,
    SpotOptions: SpotOptionsActionTypes,
    ForwardOptions: ForwardOptionsActionTypes,
    SettlementOptions: SettlementOptionsActionTypes,
    Settlement: SettlementActionTypes,
    Breakpoint: BreakpointActionTypes,
    ValueDateCalendar: ValueDateCalendarActionTypes,
    StickyHeader: StickyHeaderActionTypes
};

export const actions = {
    MainMenu: MainMenuActions,
    OptionsMenu: OptionsMenuActions,
    Locale: LocaleActions,
    HomeOptions: HomeOptionsActions,
    SpotOptions: SpotOptionsActions,
    ForwardOptions: ForwardOptionsActions,
    SettlementOptions: SettlementOptionsActions,
    Settlement: SettlementActions,
    Breakpoint: BreakpointActions,
    ValueDateCalendar: ValueDateCalendarActions,
    StickyHeader: StickyHeaderActions
};

export const reducerArray = [
    MainMenuReducer,
    OptionsMenuReducer,
    LocaleReducer,
    HomeOptionsReducer,
    SpotOptionsReducer,
    ForwardOptionsReducer,
    SettlementOptionsReducer,
    SettlementReducer,
    BreakpointReducer,
    ValueDateCalendarReducer,
    StickyHeaderReducer
];

export const selectors = {
    MainMenu: MainMenuSelectors,
    OptionsMenu: OptionsMenuSelectors,
    Locale: LocaleSelectors,
    HomeOptions: HomeOptionsSelectors,
    SpotOptions: SpotOptionsSelectors,
    ForwardOptions: ForwardOptionsSelectors,
    SettlementOptions: SettlementOptionsSelectors,
    Settlement: SettlementSelectors,
    Breakpoint: BreakpointSelectors,
    ValueDateCalendar: ValueDateCalendarSelectors,
    StickyHeader: StickyHeaderSelectors
};